<header>
  <div class="flex items-center">
    <span class="logo" title="Puntos colombia" data-cy="logo">
      <picture>
        <source srcset="/pco-front-assets/puntos-colombia-hb.svg" />
        <img alt=" " src="/pco-front-assets/puntos-colombia-hb.svg" alt="Logo Puntos Colombia" />
      </picture>
    </span>
  </div>

  <div class="action-buttons">
    <!-- User button -->
    <div>
      <img class="mr-2 icon-download" src="assets/icons/download-01.svg" routerLink="/allies/generate-file" />
    </div>
    <div (click)="menu.toggle($event)" class="btn-menu-login">
      {{ getInitials([user?.name || '']) }}
    </div>
    <!-- User menu -->
    <p-menu #menu [popup]="true" [model]="items" styleClass="topMenu">
      <ng-template pTemplate="start">
        <span class="inline-flex align-items-center gap-1 p-4">
          <div class="">
            <div class="user-name text-lg font-semibold text-gray-700">{{ user?.name }}</div>
            <div class="user-email text-xs text-gray-500 truncate">{{ user?.email }}</div>
          </div>
        </span>
      </ng-template>
    </p-menu>

    <!-- Mobile menu -->
    <p-button
      type="button"
      (click)="toggleSidebar()"
      [text]="true"
      severity="secondary"
      [icon]="(showSidebar$ | async) ? 'ico ico-x-close icon-size-20' : 'ico ico-menu-02 icon-size-20'"
      class="md:hidden"
    />
  </div>
</header>
